var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';

	var sendUser =data.sendList[0];


__p+='\n<div class="shouhu-special peidui">\n	<div class="user host">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-uid="'+
((__t=(data.uid))==null?'':__t)+
'">\n                <img node-id="img" data-src="'+
((__t=(data.avatar))==null?'':__t)+
'" data-size="42"/>\n            </span>\n            ';
if(data.showStatus ==1){
__p+='\n             <i class="uplived" node-id="liveroom" data-uid="'+
((__t=(data.uid ))==null?'':__t)+
'" data-country="'+
((__t=(data.countryCode))==null?'':__t)+
'" data-roomid="'+
((__t=(data.roomId ))==null?'':__t)+
'"></i>\n          ';
}
__p+='\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="nickname">\n                    '+
((__t=(data.username))==null?'':__t)+
'\n                </dd>\n                \n                <dd class="uplive-code">\n                    '+
((__t=(UpAct.lang.template('Up号:{code}',{code:data.upLiveCode})))==null?'':__t)+
'\n                </dd>\n                \n                \n            </dl>\n        </div>\n    </div> \n    ';

        if(!sendUser){
    
__p+='\n\n    <div class="user empty-item">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" >?</span>\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="giftcount">\n                    '+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n                </dd>\n            </dl>\n        </div>\n    </div>\n\n    ';


    }else{
    
__p+='\n    <div class="user sender">\n        <div class="avatar">\n            <span class="ui-img ui-circle" node-id="profile" data-country="'+
((__t=(sendUser.countryCode))==null?'':__t)+
'" data-uid="'+
((__t=(sendUser.uid))==null?'':__t)+
'">\n                <img node-id="img" data-src="'+
((__t=(sendUser.avatar))==null?'':__t)+
'" data-size="42"/>\n            </span>\n        </div>\n        <div class="info">\n            <dl>\n                <dd class="nickname">\n                    '+
((__t=(sendUser.username))==null?'':__t)+
'\n                </dd>\n                <dd>\n                    <div class="ui-gender" data-gender="'+
((__t=(sendUser.gender))==null?'':__t)+
'"></div>\n                    <div class="ui-grade" node-id="grade" data-grade="'+
((__t=(sendUser.grade))==null?'':__t)+
'"></div>\n                </dd>\n                <dd class="giftcount">\n                    '+
((__t=(UpAct.lang.template('贡献值:{count}', {count: UpAct.NumberUtil.separate(sendUser.giftPoint, ',')}) ))==null?'':__t)+
'\n                </dd>\n            </dl>\n        </div>\n    </div>\n\n    ';

    }
    
__p+='\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/shouhulist/shouhu-user.tmpl
// module id = 87
// module chunks = 0